import Action from '../actions/global';

const initialState = {
	userData: null,
	balance: -1,
	prizes: [],
	records: [],
	currPrizeId: '',
	address: null,
	phoneDrawRecordId: '',
	probabilityList: [],
	// 弹窗
	isLoginVisible: false,
	isRegModalVisible: false,
	isMyPrizesModalVisible: false,
	isAddressModalVisible: false,
	isOfflineModalVisible: false,
	isOffline: false,
	isUpgradeModalVisible: false,
	isPayFrameVisible: false,
	isWinModalVisible: false,

	receivedCoupon: null,
	speaker: null,
	servicePeriod: null,
	lifeLongData: null,
	soundInventory: undefined,
};
export default (state = initialState, action) => {
	switch (action.type) {
		case Action.G_SET_USERDATA:
			return {
				...state,
				userData: action.userData
			}
		case Action.G_SET_BALANCE:
			return {
				...state,
				balance: action.payload
			}
		case Action.G_SET_PRIZERS:
			return {
				...state,
				prizes: action.payload
			}
		case Action.G_SET_RECORDS:
			return {
				...state,
				records: action.payload
			}
		case Action.G_SET_ADDRESS:
			return {
				...state,
				address: action.payload
			}
		case Action.G_SET_PHONE_DRAW_RECORD_ID:
			return {
				...state,
				phoneDrawRecordId: action.payload
			}
		case Action.G_SET_CURR_PRIZE_ID:
			return {
				...state,
				currPrizeId: action.payload
			}
		case Action.G_SET_PROBABILITY_LIST:
			return {
				...state,
				probabilityList: action.payload
			}
		case Action.G_SET_OFFLINE:
			return {
				...state,
				isOffline: action.payload
			}

		// 弹窗
		case Action.G_TRIGGER_LOGIN_MODAL:
			return {
				...state,
				isLoginVisible: action.payload
			}
		case Action.G_TRIGGER_REG_MODAL:
			return {
				...state,
				isRegModalVisible: action.payload
			}
		case Action.G_TRIGGER_MY_PRIZES_MODAL:
			return {
				...state,
				isMyPrizesModalVisible: action.payload
			}
		case Action.G_TRIGGER_ADDR_MODAL:
			return {
				...state,
				isAddressModalVisible: action.payload
			}
		case Action.SHOW_OFFLINE_MODAL_VISIBLE:
			return {
				...state,
				isOfflineModalVisible: action.isOfflineModalVisible
			}
		case Action.G_TRIGGER_UPGRADE_MODAL:
			return {
				...state,
				isUpgradeModalVisible: action.isUpgradeModalVisible
			}
		case Action.G_TRIGGER_PAY_MODAL:
			return {
				...state,
				isPayFrameVisible: action.isPayFrameVisible
			}
		case Action.G_TRIGGER_WIN_MODAL:
			return {
				...state,
				isWinModalVisible: action.payload
			}

			

		case Action.SET_RECEIVED_COUPON: 
			return {
				...state,
				receivedCoupon: action.receivedCoupon
			}
		case Action.SET_SPEAKER:
			return {
				...state,
				speaker: action.speaker
			}
		case Action.SET_SERVICE_PERIOD:
			return {
				...state,
				servicePeriod: action.servicePeriod
			}
		case Action.SET_LIFE_LONG_DATA:
			return {
				...state,
				lifeLongData: action.lifeLongData
			}
		case Action.SET_SOUND_INVENTORY:
			return {
				...state,
				soundInventory: action.soundInventory
			}
		default:
			return state;
	}
};